import { render, staticRenderFns } from "./ProjectShift.vue?vue&type=template&id=5a4149a2&scoped=true"
import script from "./ProjectShift.vue?vue&type=script&lang=js"
export * from "./ProjectShift.vue?vue&type=script&lang=js"
import style0 from "./ProjectShift.vue?vue&type=style&index=0&id=5a4149a2&prod&lang=scss&scoped=true"
import style1 from "./ProjectShift.vue?vue&type=style&index=1&id=5a4149a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4149a2",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QItemSection,QIcon,QTooltip,QCard,QCardSection,QField,QBtn,QSeparator,QItem});
